import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import NotFoundPage from './pages/NotFoundPage';
import ReapproPage from './pages/ReapproPage';
import CalculStockSecuritePage from './pages/outils/CalculStockSecuritePage';
import CalculMargePage from './pages/outils/CalculMargePage';
import OutilsPage from './pages/OutilsPage';
import MargePage from './pages/MargePage';
import StockyPage from './pages/StockyPage';
import FormationPage from './pages/FormationPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import DiagnosticPage from './pages/diagnostic/DiagnosticPage';
import PartenairesPage from './pages/PartenairesPage';

// Pages importées directement (pas de React.lazy) : chaque page est pré-rendue à la compilation
// (scripts/prerender.mjs) et React doit retrouver exactement le même arbre pour s'y raccrocher.
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partenaires" element={<PartenairesPage />} />
          <Route path="/automatisation-pme" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/reappro-prevision-stock" element={<ReapproPage />} />
          <Route path="/outils" element={<OutilsPage />} />
          <Route path="/outils/calcul-stock-de-securite" element={<CalculStockSecuritePage />} />
          <Route path="/outils/calcul-marge-amazon" element={<CalculMargePage />} />
          <Route path="/marge-par-canal" element={<MargePage />} />
          <Route path="/alternative-stocky" element={<StockyPage />} />
          <Route path="/formation-ia-equipe-ecommerce" element={<FormationPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/diagnostic" element={<DiagnosticPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
